import React from "react";
import TeamTwo from "./team/TeamTwo";

import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { useTranslation } from "react-i18next";

const Team = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";
  return (
    <>
      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />

      <Breadcrumb title={"Team"} />

      <main className="page-wrapper">
        <div className="rn-team-wrapper ptb--60 bg_color--5">
          <div className="rn-team-area">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center mb--30">
                    <span className="subtitle">
                      {isEnglish ? "Our Teams" : "Notre équipe"}
                    </span>
                    <h2 className="title">
                      {isEnglish
                        ? "Our Team Members"
                        : "Les membres de notre équipe"}
                    </h2>
                  </div>
                </div>
              </div>
              <TeamTwo
                column="col-lg-3 col-md-6 col-12 mt--30"
                teamStyle=""
                item="100"
              />
            </div>
          </div>
        </div>
      </main>

      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      <Footer />
    </>
  );
};

export default Team;
